module.exports = __webpack_public_path__ + "img/1547127033.e0466314.jpg";